export default "__VITE_ASSET__CXF_Y021__"